import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLenis } from "lenis/react";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { MelbourneStats } from "@/components/MelbourneStats";
import { QuoteForm } from "@/components/QuoteForm";
import { WhyChooseUs } from "@/components/WhyChooseUs";
import { Insurance } from "@/components/Insurance";
import { Services } from "@/components/Services";
import { Marquee } from "@/components/Marquee";
import { Pricing } from "@/components/Pricing";
import { Reviews } from "@/components/Reviews";
import { Faq } from "@/components/Faq";
import { Contact } from "@/components/Contact";
import { TrustBanner } from "@/components/TrustBanner";
import { Footer } from "@/components/Footer";
import { AreasServed } from "@/components/AreasServed";
import { Seo } from "@/components/Seo";
import { PAGE_SEO } from "@/data/seo";

export default function Home() {
  const { hash } = useLocation();
  const lenis = useLenis();

  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => lenis?.scrollTo(hash, { offset: -70 }), 400);
      return () => clearTimeout(t);
    }
  }, [hash, lenis]);

  return (
    <main>
      <Seo {...PAGE_SEO.home} />
      <Header />
      <Hero />
      <QuoteForm />
      <MelbourneStats />
      <Reviews />
      <Services />
      <WhyChooseUs />
      <Insurance />
      <Marquee />
      <Pricing />
      <AreasServed />
      <Contact />
      <Faq />
      <TrustBanner />
      <Footer />
    </main>
  );
}
